import { useModal } from '../hooks/useModal';
import { useEffect } from 'react';
import { icons } from '../assets/icons';

export default function Modal() {
  const { component, isOpen, closeModal, canClose } = useModal();

  
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  // 브라우저 뒤로가기/앞으로 가기 이벤트 처리
  useEffect(() => {
    const handlePopState = () => {
      if (isOpen) {
        closeModal();
      }
    };

    if (isOpen) {
      window.addEventListener('popstate', handlePopState);
    } else {
      window.removeEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen, closeModal]);

  

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="absolute inset-0 bg-black opacity-70" onClick={()=>{
        if (canClose) {
          closeModal();
        }
      }}></div>
      
      <div className='w-full max-w-md px-5'>
      <div className="w-full max-w-md bg-white p-5 rounded-xl z-10 relative">
        {
          canClose && <button 
            onClick={closeModal}
            className="absolute top-5 right-5 text-gray-500 cursor-pointer"
            aria-label="닫기"
          >
            <img src={icons.x} className="w-5 h-5" />
          </button>
        }
        {component}
      </div>
      </div>
    </div>
  );
}